import { render, staticRenderFns } from "./EditCarInfo.vue?vue&type=template&id=90e60c18&scoped=true"
import script from "./EditCarInfo.vue?vue&type=script&lang=js"
export * from "./EditCarInfo.vue?vue&type=script&lang=js"
import style0 from "./EditCarInfo.vue?vue&type=style&index=0&id=90e60c18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e60c18",
  null
  
)

export default component.exports